module.exports = __webpack_public_path__ + "img/logo-1.f0e74a79.png";